import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { extractThumbnailPictureUrl } from "../../extractors/picturesExtractor";
import { intlShape, sessionShape } from "../../shapes";

import { withSession, withConfiguration } from "../../context";

import TypeaheadBox from "../Form/TypeaheadBox";
import { TextInput } from "../Form";
import { addAccessTokenToLcmApiUrl } from "../../utils";
import { handleFormikValueChange } from "../../utils/formikUtils";
import { useApi } from "../../hooks";

type OwnProps = {
  id?: string;
  name?: string;
  manufacturerId?: number;
  isEndress: boolean;
  intl: intlShape;
  session: sessionShape;
  configuration: {
    lcmApiUrl?: string;
  };
  assetId?: number;
  errors?: {
    productName?: $TSFixMe;
  };
  values: {
    product?: {
      manufacturer?: {
        id?: number;
      };
      new?: boolean;
      code?: string;
      name?: string;
    };
  };
};

const defaultProps: Partial<OwnProps> = {
  id: "product",
  name: "product",
  manufacturerId: undefined,
  errors: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function ProductTypeahead(props: Props) {
  const {
    intl,
    manufacturerId,
    errors,
    values,
    name,
    id,
    isEndress,
    assetId,
    session,
    configuration,
  } = props;
  const { lcmApiUrl } = configuration;
  const { token } = session;

  const [searchText, setSearchText] = useState("");
  const [filterAttribute, setFilterAttribute] = useState("product_code");
  const api = useApi();

  const filter = {
    include: "tenant,pictures",
    manufacturer_id: manufacturerId,
    include_total_count: false,
  };
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  filter[filterAttribute] = `${searchText}*`;
  const endpoint = assetId ? `/assets/${assetId}/product-options` : "/products";
  const { data, isFetching } = api.get.useQuery(endpoint, filter, {
    enabled: !!manufacturerId,
  });
  // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
  const products = data?.products?.map((product: $TSFixMe) => ({
    id: product.id,
    name: product.name,
    code: product.product_code,
    manufacturerId,
    pictureUrl: extractThumbnailPictureUrl(product.pictures),
    tenantId: product?.tenant?.id,
    tenantPublic: product?.tenant?.public,
    tenantName: product?.tenant?.name,
  }));

  const handleLoadOptions = (text: $TSFixMe, attribute: $TSFixMe) => {
    setSearchText(text);
    setFilterAttribute(attribute);
  };

  React.useEffect(() => {
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    handleLoadOptions(values[name]?.code || "", "product_code");
  }, [manufacturerId, assetId, values.product]);

  const renderOption = (option: $TSFixMe) => {
    let image = null;

    let src = option.pictureUrl;

    src = addAccessTokenToLcmApiUrl(src, lcmApiUrl, token);

    image = src ? (
      <img src={src} alt={option.productCode} />
    ) : (
      <span className="icon icon-eh-device" />
    );

    return (
      <div className="select-item">
        <div className="select-item-image">{image}</div>
        <div className="select-item-content">
          <div className="select-item-header">{option.code}</div>
          <div className="select-item-details">{option.name}</div>
        </div>
      </div>
    );
  };

  const selectedProduct = values.product;

  const productNameErrors = {};
  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  productNameErrors[name] = errors ? errors[`${name}Name`] : undefined;

  const handleOnChange = (type: $TSFixMe, value: $TSFixMe) => {
    if (
      values.product?.new &&
      !value &&
      type === "code" &&
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      values.product.name?.length > 0
    ) {
      handleFormikValueChange(props, { ...values.product, code: "" });
      return;
    }

    if (
      values.product?.new &&
      !value &&
      type === "name" &&
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      values.product.code?.length > 0
    ) {
      handleFormikValueChange(props, { ...values.product, name: "" });
      return;
    }

    if (values.product?.new && value?.new) {
      handleFormikValueChange(props, { ...values.product, ...value });
    } else {
      handleFormikValueChange(props, value);
    }
  };

  return (
    <>
      <div className="clearfix">
        <div className={isEndress ? "col-xs-6 col-sm-6 no-padding-left" : ""}>
          <TypeaheadBox
            {...props}
            data-testid="product-code-type-ahead"
            // @ts-expect-error TS(2322) FIXME: Type '{ "data-testid": string; id: string; onChang... Remove this comment to see the full error message
            id={`${id}-code`}
            onChange={(value) => handleOnChange("code", value)}
            fetching={isFetching}
            label={intl.formatMessage({ id: "label.product_code" })}
            labelKey="code"
            loadOptions={(text: $TSFixMe) =>
              handleLoadOptions(text, "product_code")
            }
            options={products}
            renderOption={renderOption}
            info={
              selectedProduct?.new
                ? intl.formatMessage({ id: "product_typeahead.new_info" })
                : null
            }
            loadOptionsOnMount={false}
            required
          />
        </div>
        {isEndress ? (
          <div className="col-xs-6 col-sm-6 input-separator no-padding-right">
            <TextInput
              {...props}
              // @ts-expect-error TS(2769) FIXME: No overload matches this call.
              required={false}
              id="order-code"
              name="orderCode"
              label={intl.formatMessage({ id: "label.extended_order_code" })}
            />
          </div>
        ) : null}
      </div>
      <TypeaheadBox
        {...props}
        data-testid="product-name-type-ahead"
        // @ts-expect-error TS(2322) FIXME: Type '{ "data-testid": string; id: string; onChang... Remove this comment to see the full error message
        id={`${id}-name`}
        onChange={(value) => handleOnChange("name", value)}
        fetching={isFetching}
        errors={productNameErrors}
        label={intl.formatMessage({ id: "label.product_name" })}
        loadOptions={(text: $TSFixMe) => handleLoadOptions(text, "name")}
        options={products}
        renderOption={renderOption}
        loadOptionsOnMount={false}
      />
    </>
  );
}

ProductTypeahead.defaultProps = defaultProps;

export default injectIntl(withSession(withConfiguration(ProductTypeahead)));
